import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const RequireAuth = () => {
  const { accessToken, isInitializing, user } = useAuth();
  const location = useLocation();

  // Wait for the stored refresh token to be exchanged before deciding whether
  // this route is available. This avoids redirecting a valid session on reload.
  if (isInitializing) {
    return null;
  }

  if (!accessToken || !user) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  return <Outlet />;
};

export default RequireAuth;
